<template>
    <div class="box_container">
         <!-- 纳入全国惩戒 -->
         <div class="title line_bottom">
            <div class="info">
                    <div class="p_info">
                        <p class="tip1">{{guideInfo.name}}</p>
                        <p class="tip2"><i>{{guideInfo.certificate}}</i></p>
                    </div>
                    <p class="tip3">{{guideInfo.travelName}}</p>
            </div>
            <div class="head_logo" :style="'background-image:url(' + guideInfo.photoPath + ');'">
            </div>
        </div>
         <div class="container1">
              <!-- 延长黑名单选择的弹框 -->
              <div class="item line_bottom" v-if="type=='longBlacklist' || type=='longAllBlacklist'||type=='longAllBlacklistCity'" @click="overTimePicker=true">
                   <div class="left">
                        <span>延长原因</span>
                        <span>*</span>
                   </div>
                   <div class="right">
                        <span :class="{'checkedWord': overTimeType !== '请选择'}">{{overTimeType}}</span>
                        <img class="r-img" src="../../assets/travelAgency/ic_righticon.png" />
                   </div>
              </div>
              <!-- 加入黑名单选择的弹框 -->
              <div class="item line_bottom" v-if="type=='addBlacklist'" @click="showAddBlack">
                   <div class="left">
                        <span>纳入类型</span>
                        <span>*</span>
                   </div>
                   <div class="right">
                        <span class="blackText" :class="{'checkedWord': blackContent!== '请选择'}">{{blackContent}}</span>
                        <img class="r-img" src="../../assets/travelAgency/ic_righticon.png" />
                   </div>
              </div>
              <!-- 纳入黑名单全国惩戒 -->
              <div class="item line_bottom" v-if="type=='addAllBlacklist'" @click="addBlackPicker = true">
                   <div class="left">
                        <span>纳入类型</span>
                        <span>*</span>
                   </div>
                   <div class="right">
                        <span :class="{'checkedWord': blackType!== '请选择'}">{{blackType}}</span>
                        <img class="r-img" src="../../assets/travelAgency/ic_righticon.png" />
                   </div>
              </div>
              <div class="item line_bottom" v-if="type=='addBlacklist'||type=='addAllBlacklist'" @click="checkoutTime(1)">
                   <div class="left">
                        <span>违规纳入日期</span>
                        <span>*</span>
                   </div>
                   <div class="right">
                        <span :class="{'checkedWord': startTime !== '请选择'}">{{startTime}}</span>
                        <img class="r-img" src="../../assets/travelAgency/ic_righticon.png" />
                   </div>
              </div>
              <div class="item line_bottom" v-if="type=='addBlacklist'||type=='addAllBlacklist'" @click="checkoutTime(2)">
                   <div class="left">
                        <span>违规退出日期</span>
                        <span>*</span>
                   </div>
                   <div class="right">
                        <span :class="{'checkedWord': endTime !== '请选择'}">{{endTime}}</span>
                        <img class="r-img" src="../../assets/travelAgency/ic_righticon.png" />
                   </div>
              </div>
              <!-- 延长黑名单 -->
              <div class="item line_bottom" v-if="type=='longBlacklist' || type=='longAllBlacklist'||type=='longAllBlacklistCity'" @click="checkoutTime(3)">
                   <div class="left">
                        <span>延长截至日期</span>
                        <span>*</span>
                   </div>
                   <div class="right">
                        <span :class="{'checkedWord': extensionTime !== '请选择'}">{{extensionTime}}</span>
                        <img class="r-img" src="../../assets/travelAgency/ic_righticon.png" />
                   </div>
              </div>
              <p class="tip4">处理备注</p>
              <div class="content_reason">
                  <textarea class="content" placeholder="请输入备注说明…" v-model="reson" :maxLength="total"></textarea>
                  <span class="total">{{changeLength}}/字</span>
              </div>
              <div class="file-contain">
                    <div class="file-title"><span>上传附件</span><span>*</span></div>
                    <div class="img-contain">
                        <div class="posting-uploader-item" v-for="(item,nn) in postData" :key="nn">
                            <img :src="item.content" alt="图片" class="imgPreview">
                            <img src="../../assets/guideSystem/delete.png" class="delte" @click="delImg(nn)">
                            <!-- <van-icon name="close" @click="delImg(nn)" class="delte"/> -->
                        </div>
                        <van-uploader :after-read="onRead" multiple="true" :accept="'image/*'">
                            <!-- <img src="../../assets/guideSystem/ic_upload.png" alt="等待传图" class="imgPreview"> -->
                        </van-uploader>
                    </div>
               </div>
               <div class="btn" :class="{'active':showActive}" @click="confirm">提交</div>
         </div>
          <timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
          <addAllBlacklist ref="addBlack" @getContent="getContent"></addAllBlacklist>
          <!-- 惩戒类型 -->
          <van-popup v-model="addBlackPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="blackColumns"
                @cancel="addBlackPicker = false"
                @confirm="blackConfirm"
            />
          </van-popup>
          <!-- 延长原因弹窗 -->
          <van-popup v-model="overTimePicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="overTimeColumns"
                @cancel="overTimePicker = false"
                @confirm="overTimeConfirm"
            />
          </van-popup>
    </div>
</template>
<script>
    import api from '../../service/modules/guide'
    import timePick from '../../components/base/timePick';
    import addAllBlacklist from './components/addBlackListTip'
    import moment from 'moment';
    const HTTPS = 'https://'
    export default {
        components: {
            timePick,
            addAllBlacklist
        },
        data () {
            return {
                total: 200,
                postData: [], // 图片显示临时存储
                tempFile: [],
                uploadTemp: [],
                type: this.$route.query.type,
                guideId: this.$route.query.guideId,
                guideBlackId: this.$route.query.guideBlackId,
                startTime: '请选择', // 开始日期
                endTime: '请选择', // 结束日期
                extensionTime: '请选择',
                changeTime: '',
                addBlackPicker: false, // 控制惩戒类型弹窗显示
                blackColumns: ['全国惩戒', '全省惩戒'],
                blackType: '请选择', // 黑名单惩戒纳入类型
                overTimePicker: false, // 控制延长原因弹窗显示
                overTimeColumns: ['导游未完成整改', '其他'], // 延长原因
                overTimeType: '请选择',
                disciplineType: '', // 全国惩戒类型
                reson: '',
                blackContent: '请选择',
                guideInfo: {},
                addCodeType: ''
            }
        },
        computed: {
            showActive () {
                if (this.type == 'addAllBlacklist') { // 全国惩戒
                    if (this.disciplineType && this.startTime && this.endTime && this.uploadTemp.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (this.type == 'addBlacklist') { // 加入黑名单
                    if (this.blackContent != '请选择' && this.startTime && this.endTime && this.uploadTemp.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (this.type == 'longAllBlacklist' || this.type == 'longBlacklist' || this.type == 'longAllBlacklistCity') { // 延长全国惩戒
                    if (this.overTimeType != '请选择' && this.extensionTime != '请选择' && this.uploadTemp.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            changeLength () {
                return (this.total - parseInt(this.reson.trim().length))
            }

        },
        created () {
            this.getUserInfo();
            if (this.type == 'addAllBlacklist') { // 纳入黑名单惩戒
                window.yyn.invokeJSB(
                    'setTitle',
                    {
                        title: '纳入黑名单惩戒' || ''
                    },
                    cb => {
                        console.log('设置title成功：', data);
                    }
                );
            } else if (this.type == 'addBlacklist') { // 纳入黑名单
                window.yyn.invokeJSB(
                    'setTitle',
                    {
                        title: '纳入黑名单' || ''
                    },
                    cb => {
                        console.log('设置title成功：', data);
                    }
                );
            } else if (this.type == 'longAllBlacklist' || this.type == 'longAllBlacklistCity') { // 延长全国惩戒
                window.yyn.invokeJSB(
                    'setTitle',
                    {
                        title: '延长全国惩戒' || ''
                    },
                    cb => {
                        console.log('设置title成功：', data);
                    }
                );
            } else if (this.type == 'longBlacklist') { // 延长黑名单
                window.yyn.invokeJSB(
                    'setTitle',
                    {
                        title: '延长黑名单' || ''
                    },
                    cb => {
                        console.log('设置title成功：', data);
                    }
                );
            }
            this.getSession();
        },
        methods: {
            getUserInfo () { // 获取用户信息
                api.guideInfo({ id: this.guideId }).then(res => {
                    this.guideInfo = res.data;
                })
            },
            getContent (val) {
                this.blackContent = val.content;
                this.addCodeType = val.type;
            },
            blackConfirm (value) { // 加入黑名单惩戒选择框
                this.blackType = value;
                this.addBlackPicker = false;
                if (value == '全国惩戒') {
                    this.disciplineType = 'national'
                } else if (value == '全省惩戒') {
                    this.disciplineType = 'provincial'
                }
            },
            confirm () { // 提交
                if (this.type == 'addBlacklist') { // 加入黑名单
                    if (this.blackContent === '请选择') {
                        this.$Toast('请选择纳入类型')
                    } else if (this.startTime == '请选择') {
                        this.$Toast('请选择违规纳入日期')
                    } else if (this.endTime == '请选择') {
                        this.$Toast('请选择违规退出日期')
                    } else if (this.uploadTemp.length == 0) {
                        this.$Toast('附件不能为空')
                    } else {
                        this.getBlack();
                    }
                } else if (this.type == 'addAllBlacklist') { // 全国惩戒
                    if (this.disciplineType == '') {
                        this.$Toast('请选择纳入类型')
                    } else if (this.startTime == '请选择') {
                        this.$Toast('请选择违规纳入日期')
                    } else if (this.endTime == '请选择') {
                        this.$Toast('请选择违规退出日期')
                    } else if (this.uploadTemp.length == 0) {
                        this.$Toast('附件不能为空')
                    } else {
                        this.getAddDiscipline();
                        //   this.getBlack();
                    }
                } else if (this.type == 'longAllBlacklist' || this.type == 'longBlacklist' || this.type == 'longAllBlacklistCity') { // 延长全国惩戒
                    if (this.overTimeType == '请选择') {
                        this.$Toast('请选择延长原因')
                    } else if (this.extensionTime == '请选择') {
                        this.$Toast('请选择延长截至日期')
                    } else if (this.uploadTemp.length == 0) {
                        this.$Toast('附件不能为空')
                    } else {
                        if (this.type == 'longAllBlacklist' || this.type == 'longAllBlacklistCity') { // 延长全国惩戒
                            if (this.$route.query.disciplineType == 'national' && !this.reson.trim()) {
                                this.reson = '延长全国惩戒'
                            } else if (this.$route.query.disciplineType == 'provincial' && !this.reson.trim()) {
                                this.reson = '延长全省惩戒'
                            }
                            this.getAllLongBlack();
                        } else if (this.type == 'longBlacklist') {
                            this.getLongBlack();
                        }
                        // else if (this.type == 'longAllBlacklistCity') {//延长全省惩戒
                        //     this.getLongBlack();
                        // }
                    }
                }
                // if (!this.disciplineType && this.type === 'addAllBlacklist') {
                //     this.$Toast('请选择惩戒类型');
                // } else if (!this.blackContent && this.type === 'addBlacklist') {
                //     this.$Toast('请选择纳入类型');
                // } else if (this.startTime == '请选择' && this.type !== 'longBlacklist' && this.type !== 'longAllBlacklist') {
                //     this.$Toast('请选择违规纳入日期');
                // } else if (this.endTime == '请选择' && this.type !== 'longBlacklist' && this.type !== 'longAllBlacklist') {
                //     this.$Toast('违规退出日期');
                // } else if (this.overTimeType == '请选择' && this.type === 'longBlacklist') {
                //     this.$Toast('请选择延长截止日期');
                // } else if (this.reson.trim().length == 0) {
                //     this.$Toast('备注说明不能为空');
                // }
                // // else if (this.uploadTemp.length == 0) {
                // //     this.$Toast('请上传附件');
                // // }
                // else { // 调用接口
                //     if (this.type === 'addAllBlacklist') { // 黑名单全国惩戒
                //         this.getAddDiscipline();
                //     } else if (this.type === 'addBlacklist') { // 加入黑名单
                //         this.getBlack();
                //     } else if (this.type === 'longBlacklist') { // 延长黑名单
                //         this.getLongBlack();
                //     } else if (this.type === 'longAllBlacklist') {
                //         this.getAllLongBlack();
                //     }
                // }
            },
            getBlack () {
                let data = {
                    guideId: this.guideId,
                    disposeType: this.addCodeType,
                    happenedDate: this.startTime,
                    disposeDesc: this.reson.trim(),
                    attach: JSON.stringify(this.uploadTemp),
                    expirDate: this.endTime

                    // expiringdate: this.endTime
                }
                api.guideAdd(data).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast.loading({
                            message: '提交成功',
                            icon: 'passed',
                            forbidClick: true
                        });
                    }
                    this.$router.go(-2);
                })
            },
            getLongBlack () { // 延长黑名单
                let data = {
                    guideId: this.guideId,
                    disposeType: this.overTimeType,
                    postponeDate: this.extensionTime,
                    disposeDesc: this.reson.trim() || '延长黑名单',
                    attach: JSON.stringify(this.uploadTemp)
                }
                api.postponeBlacklist(data).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast.loading({
                            message: '提交成功',
                            icon: 'passed',
                            forbidClick: true
                        });
                    }
                    this.$router.go(-2);
                })
            },
            getAllLongBlack () {
                let data = {
                    guideBlackId: this.$route.query.guideBlackId,
                    detailedType: this.overTimeType,
                    disciplineExpireDate: this.extensionTime,
                    disciplineDesc: this.reson.trim(),
                    attach: JSON.stringify(this.uploadTemp)
                }
                api.postponeDiscipline(data).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast.loading({
                            message: '提交成功',
                            icon: 'passed',
                            forbidClick: true
                        });
                    }
                    this.$router.go(-2);
                })
            },
            getAddDiscipline () { // 黑名单全国惩戒
                const data = {
                    guideBlackId: this.$route.query.guideBlackId,
                    disciplineType: this.disciplineType,
                    disciplineDate: this.startTime,
                    disciplineExpireDate: this.endTime,
                    disciplineDesc: this.reson,
                    attach: JSON.stringify(this.uploadTemp)
                }
                console.log(data);
                api.addDiscipline(data).then((res) => {
                    if (res.ret === 0) {
                        this.$Toast.loading({
                            message: '提交成功',
                            icon: 'passed',
                            forbidClick: true
                        });
                    }
                    this.$router.go(-2);
                })
            },
            overTimeConfirm (value) {
                this.overTimeType = value;
                this.overTimePicker = false;
            },
            showAddBlack () { // 加入黑名单显示弹窗
                this.$refs.addBlack.showTip();
            },
            // 调起时间控件
            checkoutTime (index) {
                if (index === 1) {
                    this.changeTime = 'startTime';
                    this.$refs.timePick.showPicker();
                } else if (index === 2) {
                    this.changeTime = 'endTime';
                    this.$refs.timePick.showPicker();
                } else if (index === 3) {
                    this.changeTime = 'extensionTime';
                    this.$refs.timePick.showPicker();
                }
            },
            // 选择时间
            getTimeValue (value) {
                let timeVal = new Date(value).getTime(); /** 选择时间 */
                let timeVal1 = new Date().getTime(); /** 当前时间 */
                if (this.changeTime === 'startTime') {
                    if (timeVal1 > (timeVal + 57600000)) {
                        this.$Toast({
                            message: '纳入时间不能小于当前时间'
                        });
                        return;
                    }
                    this.startTime = value;
                } else if (this.changeTime === 'endTime') {
                    if (new Date(value).getTime() < new Date(this.startTime).getTime()) {
                        this.$Toast({
                            message: '退出时间不能小于纳入时间'
                        });
                        return;
                    }
                    this.endTime = value;
                } else {
                    if ((timeVal + 57600000) < new Date().getTime()) {
                        this.$Toast({
                            message: '延长时间要大于当前时间'
                        });
                        return;
                    }
                    this.extensionTime = value;
                }
            },
            onRead (file) { // 上传图片到图片服务器
                this.tempFile = []
                if (Array.isArray(file)) {
                    // 多图
                    for (let index = 0; index < file.length; index++) {
                        this.postData.push(file[index])
                        this.tempFile.push(file[index])
                    }
                } else {
                    // 单图
                    this.postData.push(file)
                    this.tempFile.push(file)
                }
                this.uploadFile()
            },
            getSession () {
                api.getCosSession().then(res => {
                    if (res.ret === 0) {
                        this.cosArg = res.data
                        this.cos = new COS({
                            getAuthorization: function (options, callback) {
                                callback({
                                    TmpSecretId: res.data.credentials && res.data.credentials.tmpSecretId,
                                    TmpSecretKey: res.data.credentials && res.data.credentials.tmpSecretKey,
                                    XCosSecurityToken: res.data.credentials && res.data.credentials.sessionToken,
                                    ExpiredTime: res.data.expiredTime
                                });
                            }
                        })
                    }
                });
            },
            uploadFile () {
                let cosKey = ''
                console.log('this.tempFile:', this.tempFile)
                for (let i = 0; i < this.tempFile.length; i++) {
                    cosKey = `${this.cosArg.keyPrefix}/${new Date().getTime()}/${this.tempFile[i].file.name}`
                    this.cos.putObject({
                        Bucket: this.cosArg.bucket,
                        Region: this.cosArg.region,
                        Key: cosKey,
                        Body: this.tempFile[i].file,
                        onHashProgress: function (progressData) {
                            console.log('校验中', JSON.stringify(progressData));
                        },
                        onProgress: function (progressData) {
                            console.log('上传中', JSON.stringify(progressData));
                        }
                    }, (err, res) => {
                        console.log(err, res);
                        if (!err) {
                            this.uploadTemp.push(HTTPS + res.Location)
                            console.log('this.uploadTemp:', this.uploadTemp)
                        }
                    })
                }
            },
            delImg (index) {
                // 删除指定下标的图片对象
                if (isNaN(index) || index >= this.postData.length) {
                    return false
                }
                let tmp = []
                let upTmp = []
                for (let i = 0, len = this.postData.length; i < len; i++) {
                    if (this.postData[i] !== this.postData[index]) {
                        tmp.push(this.postData[i])
                        upTmp.push(this.uploadTemp[i])
                    }
                }
                this.postData = tmp
                this.uploadTemp = upTmp
                console.log('this.uploadTemp:', this.uploadTemp)
            }
        }
    }
</script>
<style scoped lang="less">
.box_container{
    width:100%;
    // height:100%;
    padding-bottom:20px;
    .title{
        width:100%;
        padding:24px 12px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .info{
            .p_info{
                display: flex;
                flex-direction: row;
                align-items: center;
                .tip1{
                    font-size:20px;
                    color:#333;
                    font-weight: 700;
                }
                .tip2{
                    border:1px solid #36B374;
                    margin-left:8px;
                    i{
                        display: inline-block;
                        font-size: 12px;
                        color:#36B374;
                        padding:4px;
                    }
                }
            }
            .tip3{
                font-size:12px;
                color:#999999;
                margin-top:13px;
            }
        }
        .head_logo{
            width:49px;
            height:49px;
            background: url(../../assets/travelAgency/ic_bm_cy1.png);
            border-radius: 3px;
            border: 1px solid rgba(238, 238, 238, 1);
            background-size: auto 100%;
            background-position: center;
            background-repeat: no-repeat;
        }
    }
    .container1{
        width:100%;
        padding:0 12px;
        box-sizing: border-box;
        .item{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            .left{
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                span:nth-child(1){
                    font-size:14px;
                    color:#999;
                }
                span:nth-child(2){
                    font-size:14px;
                    color:red;
                }
            }
            .right{
                display: flex;
                flex-direction: row;
                align-items: center;
                span{
                    font-size:14px;
                    color:#999999;
                }
                .blackText {
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  width: 236px;
                  text-align: right;
                }
                .checkedWord {
                  color: #333333;
                }
                img{
                    width:12px;
                    height:12px;
                    margin-left:2px;
                    padding:15px 0;
                }
            }
        }
        .tip4{
            font-size:14px;
            color:#999999;
            padding:16px 0 12px 0;
            box-sizing: border-box;
        }
        .content_reason{
            width:100%;
            height:180px;
            border-radius: 3px;
            position:relative;
            .content{
                width:100%;
                height:100%;
                background-color: #F9F9F9;
                border:0;
                outline: none;
                resize: none;
                padding:16px;
                font-size: 14px;
                color:#999;
                box-sizing: border-box;
                line-height: 1.3em;
            }
            .total{
                position:absolute;
                right:16px;
                bottom:16px;
                font-size:14px;
                color:#999;
            }
        }

        .file-contain{
            display: flex;
            flex-direction: column;
            margin-top:16px;
            .file-title{
                // font-size:14px;
                // font-family:PingFangSC-Regular,PingFang SC;
                // font-weight:400;
                // color:rgba(51,51,51,1);
                // line-height:14px;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                span:nth-child(1){
                    font-size:14px;
                    color:#999;
                }
                span:nth-child(2){
                    font-size:14px;
                    color:red;
                }
            }
            .img-contain{
                display: flex;
                flex-wrap: wrap;
                margin-top: 13px;
                .posting-uploader-item{
                    width: 77px;
                    height: 77px;
                    position: relative;
                    margin-right: 13px;
                    margin-bottom: 13px;
                    .imgPreview{
                        width: 100%;
                        height: 100%;
                    }
                    .delte{
                        width: 14px;
                        height: 14px;
                        position: absolute;
                        top: -7px;
                        right: -7px;
                        z-index: 10;
                    }
                }
                .van-uploader{
                    position: relative;
                    top: 0!important;
                }
                .imgPreview{
                    width: 77px;
                    height: 77px;
                }
            }
        }
        .btn{
            width:100%;
            height:50px;
            text-align: center;
            line-height: 50px;
            color:#fff;
            background:rgba(54, 179, 116, .3);
            margin-top:25px;
            font-size:16px;
        }
        .active{
          background-color:rgb(54, 179, 116);
        }
    }
}
</style>
